import { cmsApiClient } from '@/config/httpClients';
import type { PartialDataResponse, PartialResponse } from './schema';
import { PartialSchema } from './schema';

const getPartialBySlug = async ({
  slug,
}: {
  slug: string;
}): Promise<PartialDataResponse> => {
  const response = await cmsApiClient
    .get<PartialResponse>(
      `collections/partials/entries?filter[slug:is]=${slug}`
    )
    .json();

  const parsedData = PartialSchema.safeParse(response);
  if (!parsedData.success) {
    console.error('ZOD ERROR ==>', parsedData);
  }

  return response.data[0];
};

export { getPartialBySlug };
